import WarrantyListPage from "./WarrantyListPage";
import { firestore } from "firebase";
import { Warranty } from "../components/WarrantyTable";
import * as fs from "../firestore";

const WarrantyRef = firestore().collection(fs.Collection.Warranties);

export default class UserWarrantyListPage extends WarrantyListPage {
    getPageTitle(): string {
        return "保証書ダウンロード"
    }
    makeFetchWarrantyQuery(limit: number, startAfter: Warranty|null, reverseOrder: boolean) {
        let query = WarrantyRef
            .limit(limit)
            .orderBy("CreateDateTime", reverseOrder ? "asc" : "desc")
            .where("userRef", "==", firestore().collection(fs.Collection.Users).doc(this.props.user.uid))
        if (startAfter != null) {
            query = query.startAfter(startAfter.CreateDateTime);
        }
        return query;
    }
}

